(function () {
  var indexNode = document.getElementById('hjelp-search-index');
  var input = document.getElementById('hjelp-search-input');
  var results = document.getElementById('hjelp-search-results');
  if (!indexNode || !input || !results) return;
  if (typeof Fuse === 'undefined') return;

  var data;
  try { data = JSON.parse(indexNode.textContent); } catch (e) { return; }
  if (!Array.isArray(data)) data = [];

  // If opened with ?q= (e.g. a product page linking with its SKU), prefill the box
  // now; results render once the index is ready (see runUrlQuery below).
  var urlQuery = '';
  try { urlQuery = (new URLSearchParams(window.location.search).get('q') || '').trim(); } catch (e) {}
  if (urlQuery) input.value = urlQuery;

  function runUrlQuery() {
    if (!urlQuery || urlQuery.length < 2 || !fuse) return;
    render(fuse.search(urlQuery), urlQuery);
  }

  var fuse = null;
  function buildFuse() {
    if (data.length === 0) return;
    fuse = new Fuse(data, {
      keys: [
        { name: 'title', weight: 0.6 },
        { name: 'snippet', weight: 0.25 },
        { name: 'keywords', weight: 0.15 }
      ],
      threshold: 0.38,
      ignoreLocation: true,
      minMatchCharLength: 2
    });
  }
  buildFuse();

  // The PDF/document index is a static asset (1500+ entries - too many for
  // Liquid to render; see hjelp-hub.liquid). Merge it in when it arrives.
  var docsSrc = indexNode.getAttribute('data-docs-src');
  if (docsSrc) {
    fetch(docsSrc)
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (docs) {
        if (Array.isArray(docs) && docs.length) {
          data = data.concat(docs);
          buildFuse();
        }
        runUrlQuery(); // SKU/?q= search after docs merge so datasheets/manuals show
      })
      .catch(function () { runUrlQuery(); /* FAQ-only search still works */ });
  } else {
    runUrlQuery();
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Norwegian labels per doc_type. Keep in sync with hjelp-hub.liquid doc_labels array.
  var DOC_TYPE_LABELS = {
    datasheet:    'Datablad',
    manual:       'Manual',
    installation: 'Installasjon',
    certificate:  'Sertifikat',
    warranty:     'Garanti'
  };

  function badgeFor(item) {
    if (item.type === 'pdf') {
      var label = DOC_TYPE_LABELS[item.doc_type] || 'PDF';
      var modifier = item.doc_type ? ('pv-hjelp__hit-badge--' + item.doc_type) : 'pv-hjelp__hit-badge--pdf';
      return { text: label, cls: 'pv-hjelp__hit-badge ' + modifier };
    }
    return { text: document.documentElement.lang === 'sv' ? 'Fråga' : 'Spørsmål', cls: 'pv-hjelp__hit-badge' };
  }

  function render(hits, query) {
    if (hits.length === 0) {
      results.innerHTML = document.documentElement.lang === 'sv'
        ? '<div class="pv-hjelp__noresults">Inga träffar för "' + escapeHtml(query) + '". Prova en annan sökning eller skriv till oss på <a href="mailto:support@proffvolt.no">support@proffvolt.no</a>.</div>'
        : '<div class="pv-hjelp__noresults">Ingen treff for "' + escapeHtml(query) + '". Prøv et annet søk eller skriv til oss på <a href="mailto:support@proffvolt.no">support@proffvolt.no</a>.</div>';
      return;
    }
    var html = hits.slice(0, 10).map(function (h) {
      var item = h.item;
      var b = badgeFor(item);
      var snippet = item.snippet ? '<p>' + escapeHtml(item.snippet) + '</p>' : '';
      return '<a class="pv-hjelp__hit" href="' + escapeHtml(item.url) + '">' +
        '<span class="' + b.cls + '">' + escapeHtml(b.text) + '</span>' +
        '<strong>' + escapeHtml(item.title) + '</strong>' +
        snippet +
        '</a>';
    }).join('');
    results.innerHTML = html;
  }

  var debounceTimer = null;
  input.addEventListener('input', function () {
    var query = input.value.trim();
    if (debounceTimer) clearTimeout(debounceTimer);
    if (query.length < 2) { results.innerHTML = ''; return; }
    debounceTimer = setTimeout(function () {
      if (!fuse) return;
      render(fuse.search(query), query);
    }, 120);
  });
})();
